var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawCheckingBoxes2Ibd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.667,
    height: 122.237,
    viewBox: "0 0 223.667 122.237",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2f2f2;}.b{opacity:0.03;}.c{fill:#3f3d56;}.d,.g{fill:#7556e8;}.e,.i,.q{fill:none;stroke-miterlimit:10;}.e{stroke:#f2f2f2;stroke-width:2px;}.f{fill:#fff;}.g{opacity:0.3;}.h{fill:#3acc6c;}.i{stroke:#3f3d56;stroke-width:4px;}.j{fill:#57b894;}.k,.q{opacity:0.1;}.l{fill:#656380;}.m{opacity:0.2;}.n{fill:#ffc1c7;}.o{fill:#ff6584;}.p{fill:#3c354c;}.q{stroke:#000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.028)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M281.724,152.676l-9.692,12,7.725-13.384a19.361,19.361,0,0,0-3.74-1.779,19.26,19.26,0,1,0-38.407-1.051l17.506,1.152-17.2,1.545a19.288,19.288,0,0,0,8.529,12.666l9.583-6.218-7.97,7.145a19.3,19.3,0,0,0,2.448,1.053,19.256,19.256,0,0,0,12.816,20.063,19.258,19.258,0,0,0,26.2,19.824,6.607,6.607,0,0,0,.891,2.123,6.324,6.324,0,0,0,2.438,2.259,6.579,6.579,0,0,0,3.461,5.423,6.59,6.59,0,0,0,3.46,5.422,6.586,6.586,0,0,0,3.459,5.425,6.347,6.347,0,0,0,1.022,3.162c1.564,2.45,4.35,3.468,6.222,2.28s2.121-4.148.557-6.6a6.355,6.355,0,0,0-2.434-2.263,6.59,6.59,0,0,0-3.466-5.429,6.586,6.586,0,0,0-3.462-5.422,6.579,6.579,0,0,0-3.461-5.422,6.345,6.345,0,0,0-1.024-3.162,6.574,6.574,0,0,0-1.52-1.684,19.256,19.256,0,0,0-6.824-32.22,19.271,19.271,0,0,0-7.113-16.913Z",
    transform: "translate(-194.627 -128.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M624.008,189.384l-1.729,1.1,1.051-1.91a1.71,1.71,0,0,0-1.047-.38h-.027a2.048,2.048,0,0,1-.359-.027l-.587.38.253-.458a2.09,2.09,0,0,1-1.026-.777l-1.049.665.663-1.2a3.073,3.073,0,0,0-2.351-1.19,3.221,3.221,0,0,0-2.691,1.661,2.009,2.009,0,0,1-1.779.95h-.059c-1.2,0-2.182,1.366-2.182,3.041s.977,3.05,2.182,3.05a1.638,1.638,0,0,0,.76-.19,3.147,3.147,0,0,1,2.64-.051,2.759,2.759,0,0,0,2.244,0,3.151,3.151,0,0,1,2.617.051,1.636,1.636,0,0,0,.76.19c1.2,0,2.182-1.364,2.182-3.05a3.854,3.854,0,0,0-.466-1.847Z",
    transform: "translate(-497.149 -174.735)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.741,210.833a3.23,3.23,0,0,0-1.868.2,2.759,2.759,0,0,1-2.244,0,3.151,3.151,0,0,0-2.641.051,1.625,1.625,0,0,1-.76.19c-1.072,0-1.961-1.077-2.147-2.5a2.076,2.076,0,0,0,.536-.57,3.009,3.009,0,0,1,5.368-.019,2.062,2.062,0,0,0,1.779.977h.029A2.214,2.214,0,0,1,620.741,210.833Z",
    transform: "translate(-497.141 -191.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M961.008,150.384l-1.729,1.1,1.051-1.91a1.71,1.71,0,0,0-1.047-.38h-.027a2.048,2.048,0,0,1-.359-.027l-.587.38.253-.458a2.09,2.09,0,0,1-1.026-.777l-1.049.665.663-1.2a3.073,3.073,0,0,0-2.351-1.19,3.221,3.221,0,0,0-2.691,1.661,2.008,2.008,0,0,1-1.779.95h-.059c-1.2,0-2.182,1.366-2.182,3.04s.977,3.05,2.182,3.05a1.638,1.638,0,0,0,.76-.19,3.147,3.147,0,0,1,2.64-.051,2.759,2.759,0,0,0,2.244,0,3.151,3.151,0,0,1,2.617.051,1.636,1.636,0,0,0,.76.19c1.2,0,2.182-1.364,2.182-3.05a3.854,3.854,0,0,0-.466-1.847Z",
    transform: "translate(-770.109 -143.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M957.741,171.833a3.231,3.231,0,0,0-1.868.2,2.759,2.759,0,0,1-2.244,0,3.151,3.151,0,0,0-2.641.051,1.625,1.625,0,0,1-.76.19c-1.072,0-1.961-1.077-2.147-2.5a2.079,2.079,0,0,0,.536-.57,3.009,3.009,0,0,1,5.368-.019,2.062,2.062,0,0,0,1.779.977h.029A2.214,2.214,0,0,1,957.741,171.833Z",
    transform: "translate(-770.101 -160.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M788.2,235.024l2.786,1.771-1.687-3.069a2.752,2.752,0,0,1,1.682-.6h.044a3.245,3.245,0,0,0,.57-.042l.941.6-.409-.734a3.379,3.379,0,0,0,1.648-1.25l1.686,1.068-1.053-1.936a4.929,4.929,0,0,1,3.776-1.9,5.182,5.182,0,0,1,4.323,2.66,3.23,3.23,0,0,0,2.85,1.541h.095c1.935,0,3.5,2.193,3.5,4.9s-1.568,4.9-3.5,4.9a2.633,2.633,0,0,1-1.222-.306,5.053,5.053,0,0,0-4.24-.082,4.424,4.424,0,0,1-3.611,0,5.062,5.062,0,0,0-4.2.082,2.642,2.642,0,0,1-1.207.3c-1.936,0-3.5-2.193-3.5-4.9A6.229,6.229,0,0,1,788.2,235.024Z",
    transform: "translate(-640.01 -209.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M818.89,269.409a5.2,5.2,0,0,1,3,.327,4.424,4.424,0,0,0,3.611,0,5.057,5.057,0,0,1,4.241.082,2.626,2.626,0,0,0,1.22.306c1.72,0,3.149-1.731,3.447-4.015a3.313,3.313,0,0,1-.859-.927,4.835,4.835,0,0,0-8.626-.023,3.314,3.314,0,0,1-2.85,1.568h-.044A3.571,3.571,0,0,0,818.89,269.409Z",
    transform: "translate(-665.461 -237.054)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "c",
    cx: 111.833,
    cy: 3.991,
    rx: 111.833,
    ry: 3.991,
    transform: "translate(0 114.228)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.674 17.194)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 146.319,
    height: 99.077,
    rx: 20.42,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M329.318,288.24v2.2H183v-2.2a3.74,3.74,0,0,1,3.583-3.88H325.736A3.74,3.74,0,0,1,329.318,288.24Z",
    transform: "translate(-183 -284.36)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.14,
    cy: 1.14,
    r: 1.14,
    transform: "translate(2.945 1.995)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.14,
    cy: 1.14,
    r: 1.14,
    transform: "translate(5.796 1.995)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 1.14,
    cy: 1.14,
    r: 1.14,
    transform: "translate(8.646 1.995)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M347.5,503.86",
    transform: "translate(-283.65 -432.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M333.5,502.86",
    transform: "translate(-272.31 -431.722)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.328 30.509)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(0 4.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(23.008 4.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(46.016 4.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(69.024 4.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(92.032 4.159)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(0 31.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(23.008 31.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(46.016 31.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(69.024 31.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(92.032 31.07)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(0 57.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(23.008 57.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(46.016 57.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(69.024 57.981)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 19.721,
    height: 16.023,
    rx: 2,
    transform: "translate(92.032 57.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M489.579,350.324l-1.039-1.046a.551.551,0,0,0-.783,0l-6.524,6.469-2.759-2.782a.546.546,0,0,0-.776,0L476.647,354a.559.559,0,0,0,0,.785l4.189,4.222a.559.559,0,0,0,.785,0l7.958-7.9a.551.551,0,0,0,0-.785Z",
    transform: "translate(-442.285 -349.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M829.579,350.324l-1.039-1.046a.551.551,0,0,0-.783,0l-6.524,6.469-2.759-2.781a.546.546,0,0,0-.777,0L816.647,354a.559.559,0,0,0,0,.785l4.189,4.222a.559.559,0,0,0,.785,0l7.958-7.9a.55.55,0,0,0,0-.785Z",
    transform: "translate(-712.44 -349.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M601.579,480.324l-1.039-1.046a.551.551,0,0,0-.783,0l-6.524,6.469-2.759-2.781a.546.546,0,0,0-.777,0L588.647,484a.559.559,0,0,0,0,.785l4.189,4.222a.559.559,0,0,0,.785,0l7.958-7.9a.55.55,0,0,0,0-.785Z",
    transform: "translate(-531.278 -452.409)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M712.579,616.324l-1.039-1.046a.551.551,0,0,0-.783,0l-6.524,6.469-2.759-2.781a.547.547,0,0,0-.776,0l-1.05,1.027a.559.559,0,0,0,0,.785L703.836,625a.559.559,0,0,0,.785,0l7.958-7.9A.551.551,0,0,0,712.579,616.324Z",
    transform: "translate(-619.475 -560.471)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(182.05 91.758)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M1002.557,648.506c-.57-1.047.076-2.332.815-3.265s1.636-1.9,1.617-3.1c-.028-1.71-1.843-2.721-3.293-3.628a15.965,15.965,0,0,1-2.957-2.377,4.334,4.334,0,0,1-.908-1.216,4.932,4.932,0,0,1-.274-2.161q.1-3.66.363-7.314",
    transform: "translate(-992.22 -622.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M984.989,613.909a2.66,2.66,0,0,1,1.33-2.185l.6,1.182-.019-1.431a2.7,2.7,0,0,1,.88-.106,2.66,2.66,0,1,1-2.788,2.541Z",
    transform: "translate(-982.044 -611.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1008.736,703.2a2.66,2.66,0,1,0-.129-2.147l1.667,1.355-1.834-.424A2.661,2.661,0,0,0,1008.736,703.2Z",
    transform: "translate(-1001.041 -682.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M1006.156,669.8a2.66,2.66,0,0,0,.836-5.224l.015,1.1-.6-1.2h0a2.66,2.66,0,0,0-2.788,2.539,2.633,2.633,0,0,0,.114.91,2.66,2.66,0,0,0,2.427,1.872Z",
    transform: "translate(-997.13 -654.381)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M972.044,647.148a2.66,2.66,0,1,0-1.18-4.992l.471,1.292-.969-.931a2.66,2.66,0,0,0-.861,1.841,2.621,2.621,0,0,0,.067.735A2.66,2.66,0,0,0,972.044,647.148Z",
    transform: "translate(-969.502 -636.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M985.592,620.844c.616.066,1.214.258,1.832.3a1.992,1.992,0,0,0,1.687-.589,8.242,8.242,0,0,0,.492-.868,1.9,1.9,0,0,1,.673-.633,2.66,2.66,0,1,1-4.986,1.771Q985.442,620.827,985.592,620.844Z",
    transform: "translate(-982.29 -617.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M972.367,653.621a2.66,2.66,0,0,0,2.537-3.8,1.971,1.971,0,0,0-.536.536,8.707,8.707,0,0,1-.528.882,2.185,2.185,0,0,1-1.769.62c-.644-.029-1.266-.213-1.9-.272-.089,0-.179-.013-.27-.015A2.661,2.661,0,0,0,972.367,653.621Z",
    transform: "translate(-969.824 -642.513)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1006.673,676.485a2.66,2.66,0,0,0,2.558-3.755,2.182,2.182,0,0,0-.57.542c-.207.293-.336.629-.57.9a2.47,2.47,0,0,1-1.887.663c-.68-.015-1.3-.177-1.954-.228A2.66,2.66,0,0,0,1006.673,676.485Z",
    transform: "translate(-997.647 -661.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M1010,710.466a2.664,2.664,0,0,0,4.863-2.176,2.582,2.582,0,0,0-.585.523,11.6,11.6,0,0,1-.715.95,3.321,3.321,0,0,1-2.21.777A11.4,11.4,0,0,1,1010,710.466Z",
    transform: "translate(-1002.304 -689.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1011.679,735.583a7.712,7.712,0,0,1-2.74-.517c-.635-.452-3.23-.99-3.394-.266s-3.164,3.611-.789,3.622,5.522-.38,6.157-.76S1011.679,735.583,1011.679,735.583Z",
    transform: "translate(-997.319 -711.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M1004.748,742.994c2.377.019,5.522-.371,6.155-.76.483-.295.675-1.347.739-1.834h.07s-.133,1.7-.76,2.09-3.78.775-6.157.76c-.686,0-.922-.249-.908-.61C1003.977,742.853,1004.237,742.984,1004.748,742.994Z",
    transform: "translate(-997.353 -715.88)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M164.361,596.973c-.834-1.543.112-3.436,1.2-4.813s2.413-2.809,2.387-4.561c-.042-2.522-2.717-4.01-4.857-5.347a23.682,23.682,0,0,1-4.359-3.5,6.422,6.422,0,0,1-1.33-1.794,7.271,7.271,0,0,1-.4-3.189q.137-5.4.532-10.784",
    transform: "translate(-129.34 -480.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M138.392,545.913a3.93,3.93,0,0,1,1.963-3.231l.882,1.743-.027-2.109a3.934,3.934,0,1,1-2.818,3.59Z",
    transform: "translate(-114.275 -463.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M173.441,677.575a3.932,3.932,0,1,0-.19-3.166l2.455,2L173,675.781a3.917,3.917,0,0,0,.441,1.794Z",
    transform: "translate(-142.31 -568.594)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M169.555,628.309a3.934,3.934,0,0,0,1.247-7.715l.021,1.619-.891-1.762h-.01a3.933,3.933,0,1,0-.367,7.858Z",
    transform: "translate(-136.482 -526.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M119.289,594.871a3.936,3.936,0,0,0,4.112-3.746,3.884,3.884,0,0,0-.38-1.864,3.928,3.928,0,0,0-5.479-1.75l.694,1.9-1.429-1.372a3.934,3.934,0,0,0,2.47,6.828Z",
    transform: "translate(-95.763 -499.878)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M139.3,556.173c.906.1,1.79.38,2.7.439a2.928,2.928,0,0,0,2.488-.87,12.218,12.218,0,0,0,.728-1.279,2.807,2.807,0,0,1,.99-.933,3.934,3.934,0,1,1-7.352,2.611C139,556.147,139.148,556.158,139.3,556.173Z",
    transform: "translate(-114.65 -472.763)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M119.732,604.48a3.936,3.936,0,0,0,4.112-3.746,3.884,3.884,0,0,0-.38-1.864,2.925,2.925,0,0,0-.791.791,12.57,12.57,0,0,1-.779,1.3,3.23,3.23,0,0,1-2.607.912c-.948-.038-1.866-.312-2.811-.4-.131-.011-.264-.021-.4-.025a3.932,3.932,0,0,0,3.652,3.031Z",
    transform: "translate(-96.207 -509.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M170.3,638.218a3.932,3.932,0,0,0,3.772-5.537,3.171,3.171,0,0,0-.83.8,13.861,13.861,0,0,1-.855,1.33,3.641,3.641,0,0,1-2.784.977c-.973-.023-1.912-.26-2.879-.334A3.936,3.936,0,0,0,170.3,638.218Z",
    transform: "translate(-137.223 -536.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M175.32,688.32a3.934,3.934,0,0,0,7.17-3.21,3.972,3.972,0,0,0-.865.76,16.8,16.8,0,0,1-1.053,1.4,4.907,4.907,0,0,1-3.257,1.14A16.926,16.926,0,0,1,175.32,688.32Z",
    transform: "translate(-144.189 -579.338)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M177.772,725.369s-3.1-.1-4.04-.76-4.774-1.461-5.005-.393-4.665,5.321-1.161,5.342,8.143-.545,9.076-1.115S177.772,725.369,177.772,725.369Z",
    transform: "translate(-136.82 -610.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M167.546,736.308c3.5.029,8.143-.545,9.076-1.114.711-.433,1-1.988,1.089-2.7h.1s-.19,2.5-1.131,3.071-5.572,1.14-9.076,1.115c-1.011,0-1.361-.369-1.342-.9C166.406,736.1,166.786,736.3,167.546,736.308Z",
    transform: "translate(-136.856 -617.715)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(133.675 34.976)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M853.606,690.02a1.64,1.64,0,0,0-.109.445c-.54,3.557-3.649,6.183-4.783,9.6a9.206,9.206,0,0,0,.4,6.75,2.233,2.233,0,0,1,.309.975c0,.34-.272.71-.615.679a4.922,4.922,0,0,1-2.157-1.121,7.68,7.68,0,0,1-2.195-2.038,3.8,3.8,0,0,1-.649-2.864c.408-1.855,1.824-3.509,2.266-5.357l1.158-4.793a7.5,7.5,0,0,1,.951-2.558,1.58,1.58,0,0,1,.8-.679,1.9,1.9,0,0,1,.6-.047A14.441,14.441,0,0,1,853.606,690.02Z",
    transform: "translate(-812.005 -626.999)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M846.049,730.724a.641.641,0,0,1,.367.027.909.909,0,0,1,.34.435,3.981,3.981,0,0,0,1.6,1.607,4.624,4.624,0,0,1,.781.442.907.907,0,0,1,.377.774c-.055.445-.54.679-.968.812a7.261,7.261,0,0,1-2.833.248,2.483,2.483,0,0,1-1.019-.285,3.013,3.013,0,0,1-.785-.8,19.7,19.7,0,0,0-2.514-2.85,11.021,11.021,0,0,1-1.318-1.226,2.187,2.187,0,0,1-.554-1.658c.133-.883.968-1.461,1.495-2.184a14.922,14.922,0,0,1,2.215,3.469,9.99,9.99,0,0,0,.632,1.491c.241.4.588.856,1.019.6S845.421,730.833,846.049,730.724Z",
    transform: "translate(-809.208 -651.475)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M866.345,615.27a4.471,4.471,0,0,1,.3,2.011l-.031,5.072a20.4,20.4,0,0,1-.156,2.952c-.269,1.763-.992,3.431-1.308,5.187a43.924,43.924,0,0,1-.727,4.963c-.754,2.483-2.752,4.45-3.455,6.951a.788.788,0,0,1-.2.4.582.582,0,0,1-.285.122,3.032,3.032,0,0,1-1.634-.306l-3.652-1.434c-.251.109-.425-.18-.411-.458a1.329,1.329,0,0,1,.363-.724,12.14,12.14,0,0,0,1.175-1.811,16.265,16.265,0,0,0,1.7-6.553,48.424,48.424,0,0,0-.2-6.794q-.187-2.453-.374-4.9a3.516,3.516,0,0,1,.34-2.269,3.352,3.352,0,0,1,1.916-1.141A31.15,31.15,0,0,1,866.345,615.27Z",
    transform: "translate(-819.292 -578.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M866.345,615.27a4.471,4.471,0,0,1,.3,2.011l-.031,5.072a20.4,20.4,0,0,1-.156,2.952c-.269,1.763-.992,3.431-1.308,5.187a43.924,43.924,0,0,1-.727,4.963c-.754,2.483-2.752,4.45-3.455,6.951a.788.788,0,0,1-.2.4.582.582,0,0,1-.285.122,3.032,3.032,0,0,1-1.634-.306l-3.652-1.434c-.251.109-.425-.18-.411-.458a1.329,1.329,0,0,1,.363-.724,12.14,12.14,0,0,0,1.175-1.811,16.265,16.265,0,0,0,1.7-6.553,48.424,48.424,0,0,0-.2-6.794q-.187-2.453-.374-4.9a3.516,3.516,0,0,1,.34-2.269,3.352,3.352,0,0,1,1.916-1.141A31.15,31.15,0,0,1,866.345,615.27Z",
    transform: "translate(-819.292 -578.315)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M898.757,621.057a10.57,10.57,0,0,0-1.22,2.347,12.562,12.562,0,0,0-.411,1.909,41.908,41.908,0,0,0-.771,9.057,1.909,1.909,0,0,1-1.7-.421,4.854,4.854,0,0,1-1.111-1.437,15.269,15.269,0,0,1-.914-1.828,11.442,11.442,0,0,1-.866-4.454.767.767,0,0,1,.061-.363.837.837,0,0,1,.18-.214c1.994-1.889,3.142-4.481,4.239-7a12.95,12.95,0,0,0,.911-2.572,5.893,5.893,0,0,1,.761-2.606,3.277,3.277,0,0,1,2.154-1.019,4.053,4.053,0,0,1,1.739.071c.618.19,2.083.914,2.167,1.644s-1.22,1.665-1.644,2.151A41.4,41.4,0,0,0,898.757,621.057Z",
    transform: "translate(-843.707 -576.418)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M892.788,659.417c.435.73,1.043,1.546.734,2.334a1.436,1.436,0,0,1-2.12.479,3.262,3.262,0,0,1-.53-.51,52.253,52.253,0,0,1-5.1-6.706,6.588,6.588,0,0,1-1.209-2.857.6.6,0,0,1,.048-.34.655.655,0,0,1,.265-.224,13.187,13.187,0,0,1,2.942-1.223,6.24,6.24,0,0,0,.87,3.312,15.826,15.826,0,0,1,1.121,2.269c.231.571.469.615,1.063.622.479,0,.822-.058,1.053.428A25.445,25.445,0,0,0,892.788,659.417Z",
    transform: "translate(-838.95 -601.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M859.969,590c4.369.068,8.73.374,13.089.679l2.833.2a10.592,10.592,0,0,1,2.47.367,10.846,10.846,0,0,1,2.188,1.084,1.921,1.921,0,0,1,.612.489,1.828,1.828,0,0,1,.258.68,3.866,3.866,0,0,1,.16,1.569,3.825,3.825,0,0,1-.418,1.077l-1.984,3.92c-.635-.207-1.128-.622-1.749-.866a8.637,8.637,0,0,0-2.317-.442l-2.065-.2a.588.588,0,0,1-.058-.408c-1.814.632-3.621,1.22-5.435,1.851-3.329,1.158-6.665,2.32-9.872,3.788a2.034,2.034,0,0,1-1.5.262,1.569,1.569,0,0,1-.472-.312,4.855,4.855,0,0,1-1.461-2.844,10.6,10.6,0,0,1,.048-3.244c.306-2.212.975-4.525,2.667-5.982C857.849,590.872,858.787,589.968,859.969,590Z",
    transform: "translate(-818.864 -561.628)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M913.982,601.24a20.893,20.893,0,0,0-2.806,1.644,2.288,2.288,0,0,0-.37.3,2.785,2.785,0,0,0-.228.3,5.612,5.612,0,0,0-.958,1.909",
    transform: "translate(-855.497 -569.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M763.821,582.371a7.938,7.938,0,0,0-1.4,1.926c-1.036,1.631-2.524,2.942-3.547,4.583a8.551,8.551,0,0,1-1.427,2.038,4.581,4.581,0,0,1-2.779.992,6.4,6.4,0,0,0-2.646.452,4.993,4.993,0,0,0-1.59,1.7v.02a.768.768,0,0,0,.917,1.141,13.655,13.655,0,0,1,2.252-.656,14.272,14.272,0,0,0,2-.455,9.377,9.377,0,0,0,1.794-.955,11.653,11.653,0,0,0,1.41-.989c.547-.465,1.019-1.019,1.535-1.512a24.038,24.038,0,0,1,2.378-1.726,18.14,18.14,0,0,0,5.313-5.806,1.319,1.319,0,0,0,.241-.771,1.4,1.4,0,0,0-.34-.679c-.6-.764-1.148-1.39-1.984-.679C765.292,581.542,764.466,581.811,763.821,582.371Z",
    transform: "translate(-750.3 -555.479)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M827.453,532.023a1.019,1.019,0,0,0,.217.6c.224.228.595.18.914.16a3.02,3.02,0,0,1,2.4.832,5.509,5.509,0,0,1,.883,4.392,3.214,3.214,0,0,1-1.729,1.746,8.069,8.069,0,0,1-2.439.6,6.088,6.088,0,0,1-2.106,0,9.169,9.169,0,0,1-2.286-1.09,12.539,12.539,0,0,1-1.5-.849,2.377,2.377,0,0,1-.982-1.379.747.747,0,0,1,.248-.8,1.414,1.414,0,0,1,.38-.116,1.61,1.61,0,0,0,1.158-1.138c.228-.88-.319-1.767-.373-2.674a1.265,1.265,0,0,1,.16-.757,1.664,1.664,0,0,1,.764-.544l1.7-.761a10.177,10.177,0,0,1,1.6-.71c.54-.139.577.234.679.679C827.259,530.82,827.372,531.422,827.453,532.023Z",
    transform: "translate(-796.842 -521.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M827.453,532.023a1.019,1.019,0,0,0,.217.6c.224.228.595.18.914.16a3.02,3.02,0,0,1,2.4.832,5.509,5.509,0,0,1,.883,4.392,3.214,3.214,0,0,1-1.729,1.746,8.069,8.069,0,0,1-2.439.6,6.088,6.088,0,0,1-2.106,0,9.169,9.169,0,0,1-2.286-1.09,12.539,12.539,0,0,1-1.5-.849,2.377,2.377,0,0,1-.982-1.379.747.747,0,0,1,.248-.8,1.414,1.414,0,0,1,.38-.116,1.61,1.61,0,0,0,1.158-1.138c.228-.88-.319-1.767-.373-2.674a1.265,1.265,0,0,1,.16-.757,1.664,1.664,0,0,1,.764-.544l1.7-.761a10.177,10.177,0,0,1,1.6-.71c.54-.139.577.234.679.679C827.259,530.82,827.372,531.422,827.453,532.023Z",
    transform: "translate(-796.842 -521.684)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 4.236,
    cy: 4.236,
    r: 4.236,
    transform: "translate(21.955 3.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M811.456,539.014a5.824,5.824,0,0,1,1.991-.5,2.354,2.354,0,0,1,1.855.734,11.37,11.37,0,0,1,.846,1.614c.625,1.019,1.845,1.485,2.82,2.181a2.126,2.126,0,0,1,.584.571,3.122,3.122,0,0,1,.241,1.79,8.649,8.649,0,0,0,1.247,4.287,25.289,25.289,0,0,0,2.684,3.638,3.625,3.625,0,0,1,.584.866c.238.571.17,1.26.523,1.766a4.935,4.935,0,0,0-2.5.34c-1.226.506-1.284,2.3-1.862,3.5a45.546,45.546,0,0,1-3.958,6.2,7.922,7.922,0,0,0-.938,1.552,4.652,4.652,0,0,1-.109-1.756c-.068-1.315-.829-2.494-1.043-3.791a17.9,17.9,0,0,1-.112-1.957,9.363,9.363,0,0,0-.635-2.888,18.547,18.547,0,0,0-1.508-2.83,4,4,0,0,0-1.138-1.359c-.564-.367-1.342-.472-1.7-1.043a2.279,2.279,0,0,0-.34-.55,1.274,1.274,0,0,0-.394-.2,17.344,17.344,0,0,1-2.011-1.114,3.235,3.235,0,0,0-2.2-.479,27.18,27.18,0,0,1-4.7,4.307,3.808,3.808,0,0,0-1.379,1.41,7.173,7.173,0,0,1-2.232-1.668,1.133,1.133,0,0,1-.238-.34c-.173-.5.34-.941.747-1.254a10.157,10.157,0,0,0,3.377-4.494c.438-1.152.727-2.477,1.726-3.2a5.966,5.966,0,0,0,.893-.628,11.308,11.308,0,0,0,.679-1.06,1.8,1.8,0,0,1,1.885-.639,8.324,8.324,0,0,1,1.124.54,5.841,5.841,0,0,0,3.057.224l3.978-.4a1.359,1.359,0,0,0-.292-1.291,3.936,3.936,0,0,0-.527-.418A2.926,2.926,0,0,1,811.456,539.014Z",
    transform: "translate(-780.342 -527.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M817.569,506.689a3.661,3.661,0,0,1,2.13,2.086,8.473,8.473,0,0,0,.448,1.192,6.872,6.872,0,0,0,1.1,1.23,1.845,1.845,0,0,1,.618,1.478c-.034.2-.122.394-.149.595-.119.88.88,1.484,1.186,2.317.4,1.094-.469,2.4.061,3.431a10.965,10.965,0,0,0,.791,1.019c.228.34.251.951-.133,1.158-.6.323-1.291-.622-1.926-.374-.163.065-.289.2-.448.275-.445.2-.965-.194-1.111-.659a3.469,3.469,0,0,1,.027-1.447,1.75,1.75,0,0,0-.272-1.389c-.258-.3-.68-.411-.948-.679a2.471,2.471,0,0,1-.34-1.987,4.929,4.929,0,0,0-1.148-3.917.255.255,0,0,0-.18-.1.289.289,0,0,0-.18.112,8.45,8.45,0,0,1-1.522,1.26.958.958,0,0,1-.544.2.344.344,0,0,1-.34-.384,3.989,3.989,0,0,0-1.271.931,1.327,1.327,0,0,1-.1-.584,5.483,5.483,0,0,1-.679,1.04,8.465,8.465,0,0,0-.747.924,1.359,1.359,0,0,0-.19,1.131c.38,1.091,2.32.839,2.742,1.916.092.241.088.506.184.744.187.462.679.679,1.087.985s.761.826.516,1.257c-.214.37-.713.411-1.128.506a2.718,2.718,0,0,0-1.7,1.277,1.6,1.6,0,0,1-.438.6,1.233,1.233,0,0,1-.554.136,2.046,2.046,0,0,1-1.637-.34c-.533-.561-.282-1.58-.826-2.13-.126-.122-.282-.211-.4-.34a1.515,1.515,0,0,1-.3-1.138,32.531,32.531,0,0,0,.408-3.37,19.24,19.24,0,0,0-.431-2.222,5.979,5.979,0,0,1,1.209-4.889,5.239,5.239,0,0,1,3.5-1.7C815.147,506.662,816.323,506.237,817.569,506.689Z",
    transform: "translate(-789.135 -506.488)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCheckingBoxes2Ibd);
export default __webpack_public_path__ + "static/media/undraw_checking_boxes_2ibd.90780d567c89c885aebf8cd86963432c.svg";
export { ForwardRef as ReactComponent };